import React from 'react';

const Works = () => {
  return (
    <div>
      <h2>Works</h2>
      <h3>…開発中…</h3>
      <p>ただいまこのページは開発中のためご利用いただけません。</p>
    </div>
  );
};

export default Works;